import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgxSpinnerModule } from "ngx-spinner";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { ToastrModule } from "ngx-toastr";
import { FormService } from "./services/form.service";
import { HelperService } from "./services/helper.service";
import { LocalStorageService } from "./services/local-storage.service";
import { GlobalErrorHandler } from "./services/globalErrorHandler";
import { HeaderLayoutService } from "./pages/shared/layout/layout.service";
import { BsModalRef, ModalModule } from "ngx-bootstrap/modal";
import {
  NgxUiLoaderConfig,
  NgxUiLoaderModule,
  PB_DIRECTION,
  POSITION,
  SPINNER,
} from "ngx-ui-loader";
import { DatePipe } from "@angular/common";
import { TransactionStatusPipe } from "./pipes/transaction-status.pipe";
import { SharedModule } from "./pages/shared/shared.module";
import { SuccessComponentComponent } from "./pages/shared/components/success-component/success-component.component";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { MomentModule } from "angular2-moment";
import { EncryptionService } from "./services/encryption.service";
import * as Sentry from "@sentry/angular";
import { Router } from "@angular/router";
// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { environment } from "src/environments/environment";
import { FoodService } from "./services/merchant/food.service.base";
import { FoodOrderService } from "./services/merchant/food-order.service.base";
import { GoogleMapService } from "./services/google-map.service";
import { ApiFoodService } from "./services/merchant/food.service.api";
import { FoodOrderServiceApi } from "./services/merchant/food-order.service.rest";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "../assets/i18n/", ".json");
}
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "yellow",
  bgsPosition: POSITION.bottomCenter,
  bgsSize: 50,
  bgsType: SPINNER.rectangleBounce, // background spinner type
  fgsType: SPINNER.foldingCube, // foreground spinner type
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 6, // progress bar thickness
};

// Initialize Firebase
const app = initializeApp(environment.firebase);
const messaging = getMessaging(app);

@NgModule({
  declarations: [AppComponent, SuccessComponentComponent],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    PaginationModule.forRoot(),
    ModalModule.forRoot(),
    NgxSpinnerModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
  ],
  exports: [PaginationModule, NgxUiLoaderModule],
  providers: [
    DatePipe,
    TransactionStatusPipe,
    FormService,
    HelperService,
    HeaderLayoutService,
    GoogleMapService,
    LocalStorageService,
    EncryptionService,
    GlobalErrorHandler,
    BsModalRef,
    {
      provide: FoodService,
      useClass: ApiFoodService,
    },
    {
      provide: FoodOrderService,
      useClass: FoodOrderServiceApi,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
